import { createHash } from 'crypto';
import { sha256 } from 'js-sha256';

export function normalizeLocation(loc: {
	facility?: string;
	city?: string;
	zip?: string;
	state?: string;
	country?: string;
}) {
	const parts = [
		loc.facility?.toLowerCase().trim() || '',
		loc.city?.toLowerCase().trim() || '',
		loc.zip?.toLowerCase().trim() || '',
		loc.state?.toLowerCase().trim() || '',
		loc.country?.toLowerCase().trim() || '',
	];

	return parts.filter((part) => part.length > 0).join('|');
}

export function hashLocation(
	loc: {
		facility?: string;
		city?: string;
		zip?: string;
		state?: string;
		country?: string;
	},
	type: 'crypto' | 'sha256' = 'crypto'
): string {
	const normalized = normalizeLocation(loc);

	if (type === 'crypto') {
		try {
			return createHash('sha256').update(normalized).digest('hex');
		} catch {
			return sha256(normalized);
		}
	}

	return sha256(normalized);
}
